module.exports = __webpack_public_path__ + "static/media/septic@2x.2664410a.jpg";